common.View.create('crud::components.Accordion', {

    onDOMLoad()
    {
        this.initAccordionItems();
    },

    initAccordionItems()
    {
        this.element.find('.crud\\:\\:components-AccordionTab')
            .find('> .head')
            .on('click', (event) => {
                let $element = $(event.currentTarget).parent().find('> .content');

                // Slide all up?
                if( this.element.data('closeAll') ) {
                    this.element.find('.crud\\:\\:components-AccordionTab').slideUp('fast');
                }

                // Is already open?
                if( $element.is(':visible') ) {
                    $element.slideUp('fast');
                } else {
                    $element.slideDown('fast');
                }
            })
            .end();
    }

});
